import {connect} from 'react-redux'
import {bindActionCreators } from 'redux'
import * as actions from './../../actions'
import SelectTransmission from './../../components/site/select_transmission'

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(actions, dispatch)
})

const mapStateToProps = state => ({
  systemLabelMastersApi: state.systemLabelMastersApi,
  selectTransmission: state.searchFormCondition.selectTransmission,
})

const SelectTransmissionContainer = connect(mapStateToProps, mapDispatchToProps)(SelectTransmission)

export default SelectTransmissionContainer
